import { lazy, PropsWithChildren, Suspense } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import UseCaseDevopsPage from "../pages/UseCase/Devops/UseCaseDevopsPage";
import UseCaseInfraPage from "../pages/UseCase/Infra/UseCaseInfraPage";
import CenteredLoading from "../shared_components/CenteredLoading/CenteredLoading";
import NavBar from "../shared_components/NavBar/NavBar";

const UseCasesPage = lazy(() => import("../pages/UseCases/UseCasesPage"));

const UseCaseLeftNav = lazy(() => import("../shared_components/UseCaseLeftNav"));

const UseCaseDocumentationsPage = lazy(() => import("../pages/UseCase/Documentations/UseCaseDocumentationsPage"));
const UseCaseMonitoringPage = lazy(() => import("../pages/UseCase/Monitoring/UseCaseMonitoringPage"));

function LazyRoute(props: PropsWithChildren<any>) {
  return <Suspense fallback={<CenteredLoading />}>{props.children}</Suspense>;
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <NavBar />
        <Outlet />
      </>
    ),
    children: [
      {
        index: true,
        element: (
          <LazyRoute>
            <UseCasesPage />
          </LazyRoute>
        ),
      },
      {
        path: ":useCaseSlug",
        element: (
          <LazyRoute>
            <UseCaseLeftNav />
          </LazyRoute>
        ),
        children: [
          {
            path: "docs/:docSlug?/*",
            element: (
              <LazyRoute>
                <UseCaseDocumentationsPage />
              </LazyRoute>
            ),
          },
          {
            path: "monitoring/:monitoringSlug?",
            element: (
              <LazyRoute>
                <UseCaseMonitoringPage />
              </LazyRoute>
            ),
          },
          {
            path: "infra",
            element: (
              <LazyRoute>
                <UseCaseInfraPage />
              </LazyRoute>
            ),
          },
          {
            path: "devops",
            element: (
              <LazyRoute>
                <UseCaseDevopsPage />
              </LazyRoute>
            ),
          },
        ],
      },
    ],
  },
]);
